<template>
  <Appendix
    title="Phụ lục QR quốc tế"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
    :_showDetails="false"
  >
    <template #file="item">
      <AppendixQRFile :item="item" :contract="contract" />
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  import AppendixQRFile from './files/AppendixQRFile.vue'

  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, AppendixQRFile },
    data() {
      return {}
    },
  }
</script>

<style scoped></style>
